












































import { defineComponent, toRefs, PropType, ref, computed, watch, nextTick, watchEffect } from '@vue/composition-api';
import { AcoFormData, AdgroupFormData, CampaignFormData, FullNormalFormData } from '@tt4b/ttam-enums';
import { useCreativeCatalogTextValidate } from '@tt4b/ttam-hooks';
import AdText from './index';
const name = 'ttam-ad-text-catalog-compose';
export default defineComponent({
  name,
  components: {
    TtamAdText: AdText.TtamAdText,
    TtamAdTextComposeWords: AdText.TtamAdTextComposeWords,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    isDisabledCreative: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, creativeData, isDisabledCreative } = toRefs(props);
    const { transformTitle } = AdText.useCatalogTransformTitle();
    const { inputNode } = AdText.useInputNodeFocus();
    const { catalogWordList } = AdText.useCatalogWordListDataSource({ adgroupData });
    const _title = ref(transformTitle(creativeData.value.title || '', catalogWordList.value));
    const isSupportSmartText = ref(true);
    const isSupportSmartTranslation = ref(true);
    const isPullTTPostNativeAd = ref(true);
    const isTTBAPushVideoNativeAd = ref(true);
    const { refTitle: catalogTitle, isValidateSuccess } = AdText.useTitleValidateStatus();
    const textareaEle = computed(() => inputNode.value.$refs.titleInput.$refs.textarea);
    const { textareaDisabled } = AdText.useTextareaPropsDisabled({
      isDisabledCreative,
      isPullTTPostNativeAd,
      isTTBAPushVideoNativeAd,
    });
    const { plainTitle, wordList, handleInput, adjustCursor, handleKeydown, addWord } = AdText.useAdCatalogTextHandler({
      title: _title,
      textareaEle,
      catalogTitle,
    });
    const { adCatalogTextValidator } = useCreativeCatalogTextValidate({ plainTitle, wordList, title: _title });
    const wordIdList = computed(() => wordList.value.map(word => word.lexiconID));

    const clearValidate = (data: string) => {
      catalogTitle.value?.clearValidate?.();
    };
    watchEffect(() => {
      _title.value = transformTitle(creativeData.value.title || '', catalogWordList.value);
    });
    // NOTE:从素材库选择原生视频，回填了title后需要清空校验提示，blur无法监听到，因此只能用watch
    watch(
      () => _title.value,
      val => {
        nextTick(() => {
          if (isPullTTPostNativeAd.value) {
            clearValidate('title');
          }
        });
        emit('change', val);
        emit('select-word-change', wordIdList.value);
      },
      { immediate: true },
    );

    const handleFocus = () => {
      emit('focus-title', true);
    };
    const handleBlur = () => {
      emit('focus-title', false);
    };

    return {
      name,
      catalogTitle,
      inputNode,
      _title,
      textareaDisabled,
      adCatalogTextValidator,
      MAX_TITLE_LENGTH: AdText.MAX_TITLE_LENGTH,
      isValidateSuccess,
      isSupportSmartText,
      isSupportSmartTranslation,
      catalogWordList,
      handleBlur,
      handleInput,
      handleFocus,
      adjustCursor,
      handleKeydown,
      addWord,
    };
  },
});
